import { ReduxUtils } from '../dependencies';

export const Status = ReduxUtils.strictObjectAccess({
    ONLINE: true,
    OFFLINE: false,
});
